import FormflowContext from '@components/FormFlow/Util/FormflowContext';
import { IconProp } from '@fortawesome/fontawesome-svg-core';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import styled, { Theme } from '@src/styled-components';
import { Col, Icon, Row, Tooltip } from 'antd';
import React from 'react';

interface IFormflowComponentItemPropType {
    icon: IconProp;
    title: string;
    tooltipText?: string;
    onClickComponent?: any;
};

interface IFormflowComponentItemStateType { };


export default class FormflowComponentItem extends React.Component<IFormflowComponentItemPropType, IFormflowComponentItemStateType> {

    constructor(props: IFormflowComponentItemPropType) {
        super(props);
        this.state = {
        };
    }

    render() {
        const {
            title,
            tooltipText,
            icon,
            onClickComponent
        } = this.props;
        return (
            <Wrapper>
                <FormflowContext.Consumer>
                    {({ setCurrentComponent, currentSection }) => (
                        currentSection !== null &&
                        <div onClick={() => { setCurrentComponent(onClickComponent, currentSection) }} className="item-container">
                            <Row type="flex" align="middle">
                                <Col className="item-icon-container">
                                    <FontAwesomeIcon icon={icon} />
                                </Col>
                                <Col className="item-title">
                                    <span>{title}</span>
                                </Col>
                                <Col className="item-tooltip-container">
                                    <Tooltip title={tooltipText} overlayClassName="tooltip-override">
                                        <Icon type="question" className="icon" />
                                    </Tooltip>
                                </Col>
                            </Row>

                        </div>
                    )}
                </FormflowContext.Consumer>
            </Wrapper>
        );
    }
}

const Wrapper = styled.div`
    .item-container{
        cursor pointer;
        flex: 1;
        height: 42px;
        background-color: ${Theme.standard.white};
        padding: 5px;
        margin-bottom: 10px;
        border-radius: 5px;
        box-shadow: 0px 4px 10px 1px ${Theme.secondary.lightGrey};
    }

    .item-container-hover:hover{        
        background-color: ${Theme.secondary.supahLightGrey};
        cursor:not-allowed;
    }

    .item-title{        
        padding-left: 12px;
        font-size: 14px;
    }

    .item-icon-container{
        background-color: #DEDEDE;
        border-radius: 5px;
        color: #7E7E7E;
        font-size: 16px;
        height: 30px;
        margin-left: 5px;
        padding: 3px;
        text-align: center;
        vertical-align: -7px;
        width: 30px;
    }


    .item-tooltip-container{
        margin-left: auto;

        .icon{
            font-size: 18px;
            font-weight: bold;
        }

        .tooltip-override{
            background-color: ${Theme.standard.white};
            font-size:30px;
            
        }
    }
`

